import {
	CognitoUserAttribute,
	CognitoUserPool,
	CognitoUser,
	AuthenticationDetails,
	config,
} from 'amazon-cognito-identity-js';

export default class Cognito {
	static getUserPool() {
		const poolData = {
			UserPoolId: window.cognitoUserPoolId,
			ClientId: window.cognitoAppClientId,
		};
		return new CognitoUserPool(poolData);
	}

	static createUserData(username, userPool) {
		return {
			Username: username,
			Pool: userPool,
		};
	}

	/**
	 * @summary Get cognito user
	 * @description This method will return current cognito user if userData input is null
	 * Or a new cognito user if userData input is not null
	 * @param {object} userData
	 * @param {object} userPool
	 * @returns {object} cognito user
	 */
	static getCognitoUser(userData, userPool) {
		if (userData) {
			return new CognitoUser(userData);
		} else if (userPool) {
			return userPool.getCurrentUser();
		}
		return null;
	}

	static createAuthData(username, password) {
		return new AuthenticationDetails({
			Username: username,
			Password: password,
		});
	}

	static refreshToken(cognitoUser, onSuccess, onFinally) {
		if (cognitoUser) return;
		cognitoUser.getSession((err, session)=>{
			const refreshToken = session.getRefreshToken();
			if (config.credentials.needsRefresh()) {
				cognitoUser.refreshSession(refreshToken, (err, session) => {
					if (err) {
						console.log(err);
						if (typeof onFinally === 'function') onFinally();
					} else {
						const jwtToken = session.getIdToken().getJwtToken();
						config.credentials.params.Logins[
							`cognito-idp.ap-southeast-2.amazonaws.com/${window.cognitoUserPoolId}`
						] = jwtToken;
						config.credentials.refresh((err) => {
							if (err) {
								console.log(err);
								if (typeof onFinally === 'function') onFinally();
							} else {
								if (typeof onSuccess === 'function') onSuccess(jwtToken);
							}
						});
					}
				});
			}
		});
	}

	static getUserAttributes(userPool) {
		return new Promise((resolve, reject)=> {
			const cognitoUser = Cognito.getCognitoUser(null, userPool);
			if (cognitoUser) {
				cognitoUser.getSession((err, session)=>{
					cognitoUser.getUserAttributes((err, result)=>{
						if (err) {
							reject(err);
						} else {
							resolve(result);
						}
					});
				});
			}
		});
	}

	static getToken(userPool) {
		return new Promise((resolve, reject)=> {
			const cognitoUser = Cognito.getCognitoUser(null, userPool);
			cognitoUser.getSession((err, session)=>{
				if (err) {
					reject(err);
				} else {
					resolve(session.getIdToken().getJwtToken());
				}
			});
		});
	}

	static signup(params, userPool) {
		return new Promise((resolve, reject)=> {
			const attributeList = [];
			const firstname = {
				Name: 'given_name',
				Value: params.firstname,
			};

			const lastname = {
				Name: 'family_name',
				Value: params.lastname,
			};
			const attrFirstName = new CognitoUserAttribute(firstname);
			const attrLastName = new CognitoUserAttribute(lastname);

			attributeList.push(...[attrFirstName, attrLastName]);

			userPool.signUp(params.username, params.password, attributeList, null, (err, result)=> {
				if (err) {
					reject(err);
				} else {
					resolve(result);
				}
			});
		});
	}
}
